import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Activity, Heart, Sparkles, Moon, ShieldCheck, ArrowRight, Grid } from 'lucide-react';

const ScienceSection = () => {
  const keyBenefits = [
    {
      title: "Boosts Cellular Energy",
      desc: "Stimulates ATP production to improve cell function and vitality.",
      icon: Zap,
      link: "/science#energy"
    },
    {
      title: "Reduces Inflammation",
      desc: "Helps relieve pain, soreness and chronic discomfort.",
      icon: Activity,
      link: "/science#inflammation"
    },
    {
      title: "Supports Healing",
      desc: "Speeds up tissue repair and muscle recovery.",
      icon: ShieldCheck,
      link: "/science#healing"
    },
    {
      title: "Enhances Skin Health",
      desc: "Improves tone, texture and reduces fine lines.",
      icon: Sparkles,
      link: "/science#skin"
    },
    {
      title: "Improves Sleep & Mood",
      desc: "Promotes relaxation and supports better sleep and mental well-being.",
      icon: Moon,
      link: "/science#sleep"
    },
    {
      title: "Overall Wellness",
      desc: "Supports a healthier, balanced lifestyle and overall well-being.",
      icon: Heart,
      link: "/science#wellness"
    }
  ];

  return (
    <section style={{ background: '#ffffff', padding: '96px 56px', position: 'relative', overflow: 'hidden' }}>
      
      {/* Subtle Red Ambient Wave Trails Faded in Background */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `radial-gradient(circle at 50% 10%, rgba(254, 242, 242, 0.6) 0%, transparent 60%)`,
        pointerEvents: 'none',
        zIndex: 1
      }}></div>

      <div className="science-section-container" style={{ maxWidth: '1280px', margin: '0 auto', position: 'relative', zIndex: 2 }}>
        
        {/* HEADER SECTION (MATCHING Z:\infraedge\new science.png 1:1) */}
        <div style={{ textAlign: 'center', maxWidth: '820px', margin: '0 auto 56px' }}>
          
          <span style={{ fontSize: '11px', fontWeight: 900, letterSpacing: '0.15em', color: '#dc2626', textTransform: 'uppercase', display: 'block', marginBottom: '12px' }}>
            KEY BENEFITS
          </span>

          <h2 className="science-title-responsive">
            THE SCIENCE OF LIGHT.<br />
            <span style={{ color: '#dc2626' }}>THE POWER OF RESULTS.</span>
          </h2>

          <p style={{ fontSize: '15px', color: '#64748b', lineHeight: 1.65, fontWeight: 500, marginBottom: '28px' }}>
            Our Red Light Therapy Panels use clinically proven wavelengths of 660nm (Red Light) and 850nm (Near-Infrared Light) to penetrate deep into the skin and muscles, stimulating cellular energy (ATP), reducing inflammation, and accelerating natural healing.
          </p>

          {/* Decorative Divider */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', maxWidth: '240px', margin: '0 auto' }}>
            <div style={{ flex: 1, height: '1px', background: '#fca5a5' }}></div>
            <Grid size={16} color="#dc2626" />
            <div style={{ flex: 1, height: '1px', background: '#fca5a5' }}></div>
          </div>

        </div>

        {/* 6 KEY BENEFITS GRID (3 COLUMNS x 2 ROWS MATCHING new science.png) */}
        <div className="science-benefits-grid">
          {keyBenefits.map((b, idx) => {
            const IconComponent = b.icon;
            return (
              <div
                key={idx}
                style={{
                  background: '#ffffff',
                  border: '1px solid #f1f5f9',
                  borderRadius: '20px',
                  padding: '38px 30px',
                  textAlign: 'center',
                  boxShadow: '0 10px 30px -5px rgba(0, 0, 0, 0.03)',
                  transition: 'transform 0.2s ease, boxShadow 0.2s ease',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                {/* Circular Light-Red Badge */}
                <div
                  style={{
                    width: '64px',
                    height: '64px',
                    borderRadius: '50%',
                    background: '#fef2f2',
                    color: '#dc2626',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '20px',
                    boxShadow: '0 4px 12px rgba(220, 38, 38, 0.08)'
                  }}
                >
                  <IconComponent size={26} />
                </div>

                {/* Benefit Title */}
                <h3 style={{ fontSize: '18px', fontWeight: 900, color: '#0f172a', marginBottom: '10px', letterSpacing: '-0.01em' }}>
                  {b.title}
                </h3>

                {/* Benefit Description */}
                <p style={{ fontSize: '13.5px', color: '#64748b', lineHeight: 1.6, margin: 0 }}>
                  {b.desc}
                </p>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default ScienceSection;
